import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import API from "../api";
import { setNotifications } from "action";
import Notification from "components/Notification/Notification";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import NotificationIcon from "../assets/images/images_new/notification.png"
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";

function Notifications() {
  const [clicked, setClicked] = useState(null);
  const [loading, setLoading] = useState(true);

  const notifications = useSelector((state) => state.notifications);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const response = await API({ url: "getNotifications", method: "GET" });
        if (response.status === 200) {
          dispatch(setNotifications(response.data));
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, [dispatch]);

  const handleClear = async (id) => {
    setClicked(id);
    let response = await API({
      url: "markNotificationAsRead",
      method: "POST",
      data: { id },
    });

    if (response.status === 200) {
      dispatch(setNotifications(response.data));
    } else {
      setClicked(null);
    }
  };

  return (
    <div className="content p-0 w-100 vh-100 position-relative">
      <DashboardHeader title="Notifications" />
      {
        notifications.length < 0 ? (
          <div className="transation-page payment-successful outer-wrapper">
            <div className="successful-content">
              <img src={NotificationIcon} alt="No Notification" />
              <h2>No Notification</h2>
              <p>your updates and alerts would appear here</p>
              <div className="payment-btns">
                <Link
                  to="/admin/dashboard"
                  className="pay-btn dashboard-btn"
                >Go To Dashboard</Link>

                <Link
                  to="/admin/test-material"
                  className="pay-btn manage-btn"
                >Practice Material</Link>
              </div>
            </div>
          </div>
        ) : (
          <Row>
            <Col xs={12}>
              <Card className="border-0 m-4 w-auto p-0" style={{borderRadius:"12px"}}>
                {/* <CardHeader className="px-4">
                  <CardTitle tag="h4" >Notifications</CardTitle>
                </CardHeader> */}
                <CardBody className="px-4 rounded-4">
                  {
                    loading ? (
                      <Spinner />
                    ) : notifications.length === 0 ? (
                      <div className="text-center py-5 ">
                        {/* <h4>No Notifications Found</h4> */}
                          <EmptyData text="No Notifications Found" />
                      </div>
                    ) :
                   notifications.map((notification) => {
                      return (
                        <Notification
                          key={notification.id}
                          notification={notification}
                          clicked={clicked}
                          handleClear={handleClear}
                        />
                      );
                    })
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        )
      }
    </div>
  );
}

export default Notifications;
